import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  grid: {
    maxWidth: theme.breakpoints.values['md'],
    padding: theme.spacing(2),
    margin: 'auto',
  },
  formGrid: {
    padding: theme.spacing(1),
    width: '100%',
    minWidth: 200,
    alignItems: 'flex-start',
    margin: 'auto',
  },
  formLabel: {
    fontSize: '.75rem',
  },

  fixedWidth: {
    width: 300,
  },

  mobileFormContainer: {
    // width: '16rem',
  },
  formItem: {
    width: '100%',
    // marginTop: theme.spacing(2),
  },
  tinyMarginTop: {
    marginTop: theme.spacing(0.5),
  },
  smallMarginTop: {
    marginTop: theme.spacing(1),
  },
  mediumMarginTop: {
    marginTop: theme.spacing(1.5),
  },
  formControlPadding: {
    '& label + .MuiInput-formControl': {
      marginTop: theme.spacing(0.5),
    },
  },

  datePickerPadding: {
    '& label + .MuiInput-formControl': {
      marginTop: theme.spacing(2),
    },
    width: '100%',
    marginTop: theme.spacing(1),
  },
  dateRangeRowPadding: {},
  hidden: {
    display: 'none',
  },
  icon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  flexFilters: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    maxWidth: '560px',
    justifyContent: 'space-around',
    alignItems: (props) => (props.isMobile ? 'center' : 'flex-start'),
  },
  btnGroup: {
    margin: '5px 0',
    backgroundColor: 'transparent',

    '& > button': {
      borderRadius: 100,
      padding: '0px 15px',
    },
  },
  checkRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  filterRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '& .FilterBtn': {
      marginRight: theme.spacing(1),
    },
  },
  filterRowMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  checkIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.primary,
    marginRight: theme.spacing(1),
  },
  smallText: {
    lineHeight: 1.2,
    '& div': {
      display: 'contents',
      fontSize: '0.7rem',
    },
  },
  linkText: {
    cursor: 'pointer',
    fontSize: '.75rem',
    whiteSpace: 'nowrap',
    minWidth: 'auto',
  },

  compareRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  compareClose: {
    height: 35,
    position: 'relative',
    top: 7,
  }
}));

export default useStyles;
